// @ts-strict

import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-join-program-alert',
  templateUrl: './join-program-alert.component.html',
  styleUrls: ['./join-program-alert.component.scss']
})
export class JoinProgramAlertComponent {
  @Input() hideIcon = false;
  @Input() buttonText?: string;
  @Input() hideButtonIcon?: boolean;
  @Input() secondButtonText?: string;
  @Input() redirectButton?: boolean;
  @Input() type?: 'success' | 'warning' | 'info' | 'danger' | 'neutral';
  @Input() iconOverride?: string;
  @Input() containerText?: { withTranslation: boolean; text: string };
  @Input() containerTextTitle?: { withTranslation: boolean; text: string };
  @Input() containerTextDesc?: { withTranslation: boolean; text: string };
  @Input() containerTextDesc2?: { withTranslation: boolean; text: string };
  @Input() hideLinkStatus?: string;
  @Output() openModal = new EventEmitter<void>();
  @Output() secondButtonAction = new EventEmitter<void>();
  @Output() redirectAction = new EventEmitter<void>();

  public icon = 'warning';
  public icons = {
    success: 'check-circle',
    info: 'info-2',
    warning: 'warning',
    danger: 'cross-circle',
    chat: 'info-2',
    neutral: 'info-2'
  };

  public get successType(): boolean {
    return this.type === 'success';
  }
  public get infoType(): boolean {
    return this.type === 'info';
  }
  public get warningType(): boolean {
    return this.type === 'warning';
  }
  public get dangerType(): boolean {
    return this.type === 'danger';
  }

  public get neutralType(): boolean {
    return this.type === 'neutral';
  }

  public get getButtonColor(): string {
    switch (this.type) {
      case 'success':
        return 'primary';
      case 'warning':
        return 'orange';
      case 'danger':
        return 'red';
      case 'info':
        return 'blue';
      case 'neutral':
        return 'grey';
      default:
        return 'primary';
    }
  }

  public openModalHandler(): void {
    this.openModal.emit();
  }

  public secondButtonHandler(): void {
    this.secondButtonAction.emit();
  }
  public redirectHandler(): void {
    this.redirectAction.emit();
  }
}
